import React from "react";
import styled from "styled-components";

export default styled.span`
    position: absolute;
    top: 5px;
    right: 15px;
    font-size: 30px;
    cursor: pointer;
    z-index: 5;
    
    img {
        width: 20px;
    }
`;